import { render } from "./CFooter.vue?vue&type=template&id=d7ee2a22&scoped=true"
const script = {}

import "./CFooter.vue?vue&type=style&index=0&id=d7ee2a22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ee2a22"]])

export default __exports__